import { render } from "./ShowOldMeeting.vue?vue&type=template&id=3891423a"
import script from "./ShowOldMeeting.vue?vue&type=script&lang=js"
export * from "./ShowOldMeeting.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__